<div class="confirm-dialog-modal">
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title drop-modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>

  <div class="modal-body">
    <p class="confirm-message mb-0">{{ message }}</p>
  </div>

  <div class="modal-footer border-0">
    <button type="button" class="btn btn-cancel-secondary w-100 mb-2" (click)="onCancel()">{{ cancelLabel }}</button>
    <button type="button" class="btn w-100" [ngClass]="confirmButtonClass" (click)="onConfirm()">{{ confirmLabel }}</button>
  </div>
</div>
